<!-- 

/financeiro/fluxodecaixa

-->

<script>
import axios from 'axios'
import BarList from '../components/bar-list'
import BarGrid from '../components/bar-grid'
import FilterList from '../components/filter-list'
import Filtro from "../consultas/filtro";
import { objectToCsv, downloadCsvReport } from '../shared/csvReport'
import { formatDataExtenso } from '../shared/utils'
import { apiORDS, apiORDSpost, apiDownload2 } from '../shared/api-functions'
import { GChart } from 'vue-google-charts/legacy';

import Chart from '../consultas/chart.vue';

export default {
    data () {
        return {
            filter: '',
            metadata: this.$store.getters.getEntities.metadata,
            moreActionsBarList: [],
            monthFilter: {},
            statusQuery: '',
            filterList: [],
            paramFilterList: {},
            showForm: false,
            codfin: '',
            url: '',
            textQuery: '',
            dados: [],
            resumo: [],
            totais: null,
            fluxoCaixaDados: null,
            showModal: false,
            showModalDiario: false,
            dadosDetalhes: '',
            contas: null,
            listContas: null,
            atrasos: false,
            atrasosTempo: null,
            tipo: 'M',  
            tipoOptions: [{ id: 'D', text: "Diário" }, { id: 'M', text: "Mensal" }],

            //OBJETO PARA MONTAGEM DO FILTRO DA CONSULTA
            showfiltro: false,
            paramsFiltro: {
                periodo: {
                label: "Período",
                varios: false,
                data_inicio: null,
                data_termino: null,
                },
                filtros: [
                    { 
                    nome: "formapagamento", 
                    label: null, 
                    url: null, 
                    varios: false, 
                    values: [] 
                    },
                    { 
                    nome: "filial", 
                    label: null, 
                    url: null, 
                    varios: false, 
                    values: [] 
                    },
                ],
            },
            filtro: {
                periodos: [{ data_inicio: null, data_termino: null }],
            },

            periodo: { data_inicio: null, data_termino: null, startDate: null, endDate: null },

            chart: { },

            diario: {
                dataDia: '',
                diarioDetalhes: []
            }
            
        }
    },

    computed: {

    },

    watch: {
        
    },

    methods: {
        handleShowFiltro() {
            this.showfiltro = true;
        },

        filtroChange(filtro) {
            // this.showfiltro = false;

            // this.filtro = filtro;
            // this.paramsFiltro.filtros[0].values = this.filtro.formapagamento
            // this.paramsFiltro.filtros[1].values = this.filtro.filial

            // this.loadData(false);
        },

        closeForm() {
            this.showForm = false
            this.loadData(false)
        },

        showModalDetalhes(dados, idxPeriodo) {

            let dataIni = null;
            let dataFim = null;
            if (this.fluxoCaixaDados.periodos[idxPeriodo].inicio)
              dataIni = new Date(this.fluxoCaixaDados.periodos[idxPeriodo].inicio)
            if (this.fluxoCaixaDados.periodos[idxPeriodo].termino)  
              dataFim = new Date(this.fluxoCaixaDados.periodos[idxPeriodo].termino)
            let data = null

            let detalhes = dados.detalhes.filter(function (obj) {
                data = new Date(obj.dtvr)
                if ((!dataIni) || (!dataFim) || (data >= dataIni && data <= dataFim))
                  return obj
            })

            this.dadosDetalhes = {...dados}
            this.dadosDetalhes.detalhes = detalhes

            this.showModal = true
        },

        showModalDetalhesDiario(detalhes, dataDia) {
            this.diario.dataDia = dataDia
            this.diario.diarioDetalhes = detalhes
            this.showModalDiario = true
        },

        closeModalDetalhes() {
            this.showModal = false
            this.showModalDiario = false
        },

        handleLoadDataFilter() {
            this.loadData(false)
        },

        loadData(excel) {
            let url = "consulta/vendas/fluxodecaixa";

            this.periodo.data_inicio = this.periodo.startDate
            this.periodo.data_termino = this.periodo.endDate

            this.filtro.periodos = [ this.periodo ]
            this.filtro.excel = excel;
            if (this.contas && this.contas.length == 0)
                this.filtro.contas = null
            else
                this.filtro.contas = this.contas;
            this.filtro.atrasos = this.atrasos;
            this.filtro.atrasosTempo = this.atrasosTempo;
            this.filtro.tipo = this.tipo;

            if (excel) 
                apiDownload2(this, url, this.filtro, "post")
            else {
                this.mounting = true
                let self = this
                apiORDSpost(this.$store, url, this.filtro, "post").then((data) => {
                    if (data.flx == undefined) {
                        self.fluxoCaixaDados = []
                        return
                    }
                    if (data.flx && data.flx.dados.length){
                        self.fluxoCaixaDados = data.flx
                        self.fluxoCaixaDados.despesas.map( (value, i) =>{
                            if(Math.sign(value) == -1){
                                self.fluxoCaixaDados.despesas[i] = value * -1
                                console.log(value)
                            }
                        })
                    }
                    else  
                      self.fluxoCaixaDados = null

                    console.log(data)
                    console.log(self.fluxoCaixaDados.despesas)
                    this.handleChart()
                })
            }
        },

        async getContas() {
            const params = null
            const modulo = 'select/cta/'
            const data = await apiORDS(this.$store.getters.urlOrds + modulo, params)
            if (data.items) {
                const contas = this.changeObjKey(data.items)
                this.listContas = contas
            }
        },
        // Muda a chave do objeto para que seja carregado corretamente no select2
        changeObjKey(arr) {
            return arr.map(entry => {
                return Object.keys(entry).reduce((obj, key) => {
                    const value = entry[key] // ler o valor
                    if (key === 'value') key = 'text' // mudar o nome da chave
                    obj[key] = value
                    return obj
                }, {})
            })
        },

        handleChart() {
            this.chart.type = 'ComboChart';

            this.chart.data = [
                [
                    'Período',
                    'Receita',
                    'Despesa',
                    'Saldo'
                ]
            ];

            this.chart.options = {
                title: '',
                vAxis: { title: 'Valores' },
                hAxis: { title: 'Períodos' },
                seriesType: 'bars',
                series: { 2: { type: 'line' } },
                width: 1050,
                height: 500,
            };

            if (this.tipo === 'M') {
                this.fluxoCaixaDados.periodos.forEach((e, index) => {
                    this.chart.data.push(
                        [
                            e.label, 
                            this.fluxoCaixaDados.receitas[index], 
                            this.fluxoCaixaDados.despesas[index], 
                            this.fluxoCaixaDados.saldoAcumulado[index]
                        ]
                    )

                    
                })
            }

            if (this.tipo === 'D') {
                this.fluxoCaixaDados.dados.forEach(e => {
                    this.chart.data.push(
                        [
                            e.data === 'Atrasos' ? e.data : formatDataExtenso(e.data, true), 
                            e.receitas, 
                            e.despesas, 
                            e.saldo
                        ]
                    )
                })
            }

            // console.log(this.chart.data)
        },

        formatColorValue(value) {
            if (value < 0) {
                return 'negative'
            }

            if (value > 0) {
                return 'positive'
            }

            return ''
        }
    },

    filters: {

    },

    components: {
        BarList, BarGrid, FilterList, Filtro, GChart, Chart
    },
    // destroyed(){
    //     localStorage.removeItem('loadChart')
    // },
    created () {
        // const loadChart = localStorage.getItem('loadChart');

        // if(!loadChart){
        //     document.location.reload(true)
        // }

        // localStorage.setItem('loadChart', true);

        this.tipo = 'M'
        this.atrasos = true
        this.atrasosTempo = 60
        this.getContas()

        this.periodo.data_inicio = this.$firstDay(this.$getDate())
        this.periodo.data_termino = this.$lastDay(this.$getDate())
        this.periodo.startDate = this.$firstDay(this.$getDate())
        this.periodo.endDate = this.$lastDay(this.$getDate())
        this.loadData(false)
    }
}
</script>

<template>
    <div>         
        <div class="default-container">
            <div class="row">
                <div class="col-12 mb-2">
                    <span class="lbl-deal-title mb-2 w-100">CONSULTA FLUXO DE CAIXA</span>
                    <!-- <v-button label="Dashboard" icon="fa-bar-chart" class="float-right" @click="clickRetornar"></v-button> -->
                </div>
            </div>
            <hr />
            <div class="row">
                <div class="col-md-4 col-12">
                    <v-label label="Período"></v-label>
                    <!-- <input-month2 :p-month="periodo" @monthChange="handlePeriodoChange(index)"></input-month2> -->
                    <input-month2 :p-month="periodo"></input-month2>
                </div>
                <form-field v-model="contas" type="select2static" col="4" label="Selecione as Contas"
                    :select-options="listContas" :selectMultiple="true" placeholder="Todas as Contas"></form-field>
                <form-field v-model="tipo" type="select" col="2" label="Tipo de Fluxo"
                    :select-options="tipoOptions" @input="handleLoadDataFilter"></form-field>
            </div>
            <div class="row">
                <div class="col-4">
                    <input-checkbox :estilo="'text-info'" label="Considerar Contas Atrasadas" v-model="atrasos" :value-checked="true" :value-unchecked="false"></input-checkbox>
                </div>
                <div class="w-100"></div>
                <form-field v-if="atrasos" v-model="atrasosTempo" type="number" col="3" label="Tempo das Contas Atrasadas (Dias)"></form-field>
            </div>
            
            <hr>

            <div class="row">
                <div class="col-12">
                    <v-button label="Filtrar" :success="true" @click="loadData"></v-button>
                    <!-- <v-button title="Atualizar Grid" icon="fa-refresh" @click="loadData"></v-button> -->
                    <v-button label="Excel" @click="loadData(true)"></v-button>
                </div>
            </div>
            
            <hr>

            <div class="row">
                <div class="col-12 lbl-title">
                    Gráfico Fluxo de Caixa
                </div>
                <!-- Valor da propriedade settings relacionado a language, só está sendo carregado quando usuário chama o evento refresh da páagina (f5)-->
                <GChart
                    v-if="chart.type" 
                    :settings="{ packages:['corechart'], language: 'pt-br' }"
                    :type="chart.type" 
                    :data="chart.data" 
                    :options="chart.options"
                />
            </div>            

            <hr>

            <div class="row">
                <div class="col-12 lbl-title">
                    Saldos Iniciais
                </div>

                <div class="col-md-6 col-12 lbl-title">
                    <table class="table table-bordered table-sm responsive w-100 bg-light" v-if="fluxoCaixaDados && fluxoCaixaDados.contas">
                        <thead>
                            <tr>
                                <th colspan="1" class="numerico size100 textual text-center">
                                    CONTA
                                </th>
                                <th colspan="1" class="numerico size100 textual text-center">
                                    SALDO
                                </th>
                            </tr>
                        </thead>
                        <tbody>                    
                            <tr v-for="(conta, index) in fluxoCaixaDados.contas" :key="index">
                                <th class="textual text-center value-bg-color">
                                    <span>
                                        {{ conta.descricao }}
                                    </span>
                                </th>
                                <td class="numerico size100 text-center value-bg-color">
                                    <span>
                                        {{ conta.saldo | formatValue(2) }}
                                    </span>
                                </td>
                            </tr>
                        </tbody>
                        <tfoot>
                            <!-- Table Footer -->
                        </tfoot>
                    </table>
                </div>
            </div>

            <div class="row mb-2">
                <div class="col-12 lbl-title">
                    Fluxo de Caixa
                </div>
                <div class="col-auto">
                    <label class="lbl-list">Data de Início</label>
                    <span class="data-list">{{ periodo.data_inicio | formatData }}</span>
                </div>
                <div class="col-auto">
                    <label class="lbl-list">Data de Término</label>
                    <span class="data-list">{{ periodo.data_termino | formatData }}</span>
                </div>
            </div>
            <div class="row mb-5" v-if="!fluxoCaixaDados">
                <div class="col-12 p-3">
                    Nenhum movimento encontrado
                </div>
            </div>

        <!-- MENSAL/SEMANAL -->
            <div class="data-table bg-light" v-if="fluxoCaixaDados && tipo == 'M'">
                <table class="table table-bordered table-sm responsive w-100">
                    <thead>
                        <tr>
                            <th colspan="1"></th>
                            <th colspan="1" class="numerico size100 textual text-center" v-for="(periodo, i) in fluxoCaixaDados.periodos" :key="i">
                                {{ periodo.label }}
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <th scope="row" class="textual">SALDO INICIAL</th>
                            <td class="numerico size100 value-bg-color" v-for="(saldoI, i) in fluxoCaixaDados.saldoInicial" :key="i"><span :class="formatColorValue(saldoI)">{{ saldoI | formatValue(2, true) }}</span></td>
                        </tr>
                        <tr>
                            <th scope="row" class="textual">RECEITAS</th>
                            <td class="numerico size100 value-bg-color" v-for="(receita, i) in fluxoCaixaDados.receitas" :key="i"><span :class="formatColorValue(receita)">{{ receita | formatValue(2, true) }}</span></td>
                        </tr>
                        <tr>
                            <th scope="row" class="textual">DESPESAS</th>
                            <td class="numerico size100 value-bg-color" v-for="(despesa, i) in fluxoCaixaDados.despesas" :key="i"><span :class="formatColorValue(despesa)">{{ despesa | formatValue(2, true) }}</span></td>
                        </tr>
                        <tr>
                            <th scope="row" class="textual">SALDO FINAL (SALDO INICIAL + RECEITAS - DESPESAS)</th>
                            <td class="numerico size100 value-bg-color" v-for="(saldoA, i) in fluxoCaixaDados.saldoAcumulado" :key="i"><span :class="formatColorValue(saldoA)">{{ saldoA | formatValue(2, true) }}</span></td>
                        </tr>
                        <tr v-if="fluxoCaixaDados && fluxoCaixaDados.periodos">
                            <th :colspan="fluxoCaixaDados.periodos.length + 1" class="text-center" scope="row">CATEGORIAS</th>
                        </tr>
                        
                        <tr v-for="(dados, i) in fluxoCaixaDados.dados" :key="i">
                            <th class="textual">
                                <div :Class="'lvl-' + dados.nivel">
                                    {{ dados.descricao }}
                                </div>
                            </th>
                            <td class="numerico size100 value-bg-color" v-for="(valor, i) in dados.valores" :key="i">
                                <span :class="formatColorValue(valor)">
                                    <i class="fa fa-search fa-fw" v-if="!dados.haschildren && valor" @click="showModalDetalhes(dados, i)"></i> 
                                    {{ valor | formatValue(2, true) }}
                                </span>
                            </td>
                        </tr>
                    </tbody>
                    <tfoot>
                        <!-- <tr>
                            <th colspan="1" class="text-center"></th>
                            <th colspan="1" class="numerico size100" v-for="(periodo, i) in fluxoCaixaDados.periodos" :key="i">
                                {{ periodo.label }}
                            </th>
                        </tr> -->
                    </tfoot>
                </table>



                <!-- Modal Detalhes -->
                <div class="nb-modal-scrollable" v-if="showModal">
                    <div class="container nb-modal-scrollable-container nb-email-container">
                        <div class="nb-modal-header">
                            <h5 class="p-2">Detalhes da natureza "{{ dadosDetalhes.descricao }}"</h5>
                            <button type="button" class="close" @click="closeModalDetalhes()" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="nb-modal-scrollable-body">
                            <div class="mainbox">
                                <div class="box" v-for="(valorDetalhes, index) in dadosDetalhes.detalhes" :key="index">
                                    <div class="row">
                                        <div class="col-md-1 col-3" style="float: left">
                                            <label class="lbl-list w-100">Documento</label><span class="data-list">{{ valorDetalhes.doc }}</span>
                                        </div>
                                        <div class="col-md-3 col-3">
                                            <label class="lbl-list w-100">Nome</label><span class="data-list">{{ valorDetalhes.nome }}</span>
                                        </div>
                                        <div class="col-md-2 col-3">
                                            <label class="lbl-list w-100">Descrição</label><span class="data-list">{{ valorDetalhes.descricao }}</span>
                                        </div>
                                        <div class="col-md-1 col-3">
                                          <label class="lbl-list w-100">Valor</label><span class="data-list">{{ valorDetalhes.vlr | formatValue(2, true) }}</span>
                                        </div>
                                        <div class="col-auto text-center">
                                            <label class="lbl-list w-100">Tipo</label>
                                            <span v-if="valorDetalhes.tipo == 'R' || valorDetalhes.tipo == 'E'" class="tipo tipo-recebimento" data-toggle="tooltip" data-placement="top" title="Recebimento"> {{ valorDetalhes.tipo }} </span>
                                            <span v-if="valorDetalhes.tipo == 'P' || valorDetalhes.tipo == 'S'" class="tipo tipo-pagamento" data-toggle="tooltip" data-placement="top" title="Pagamento"> {{ valorDetalhes.tipo }} </span>
                                        </div>
                                        <div class="col-md-2 col-3">
                                            <label class="lbl-list w-100">Vencimento</label><span class="data-list">{{ valorDetalhes.dtv | formatData }}</span>
                                        </div>
                                        <div class="col-md-2 col-3">
                                            <label class="lbl-list w-100">Vencimento Real</label><span class="data-list">{{ valorDetalhes.dtvr | formatData }}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="nb-modal-scrollable-footer">
                                <v-button ref="btnClose" label="Fechar" title="" @click="closeModalDetalhes()"></v-button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- DIARIO -->
            <div class="row">
                <div class="col-lg-6 col-md-12 col-12">
                    <div class="data-table table-sm bg-light mt-2" v-if="fluxoCaixaDados && tipo == 'D'">
                        <table class="table table-bordered responsive w-100">
                            <thead>
                                <tr>
                                    <th colspan="1" class="text-center">
                                        Data
                                    </th>
                                    <th colspan="1" class="text-center">
                                        Receitas
                                    </th>
                                    <th colspan="1" class="text-center">
                                        Despesas 
                                    </th>
                                    <th colspan="1" class="text-center">
                                        Saldo
                                    </th>
                                </tr>
                            </thead>
                            <tbody>                    
                                <tr v-for="(dados, i) in fluxoCaixaDados.dados" :key="i">
                                    <th class="textual text-center">
                                        <span>{{ dados.data | formatData }}</span>
                                        <span class="float-right">
                                            <i 
                                                class="fa fa-search fa-fw" 
                                                v-if="dados.receitas || despesas" 
                                                @click="showModalDetalhesDiario(dados.detalhes, dados.data)"
                                            >
                                            </i>
                                        </span>
                                    </th>
                                    <th class="numerico size100  value-bg-color"><div>{{ dados.receitas | formatValue(2) }}</div></th>
                                    <th class="numerico size100  value-bg-color"><div>{{ dados.despesas | formatValue(2) }}</div></th>
                                    <th class="numerico size100  value-bg-color"><div>{{ dados.saldo | formatValue(2) }}</div></th>
                                </tr>
                            </tbody>
                            <tfoot>
                                <tr>
                                    <th colspan="1" class="text-center">Total</th>
                                    <th class="numerico size100 value-bg-color"> {{ fluxoCaixaDados.receitasTotal | formatValue(2) }} </th>
                                    <th class="numerico size100 value-bg-color"> {{ fluxoCaixaDados.despesasTotal | formatValue(2) }} </th>
                                    <th class="numerico size100 value-bg-color"></th>
                                </tr>
                            </tfoot>
                        </table>
                    </div>
                </div>
            </div>

            <!-- Modal Detalhes Diário -->
            <div class="nb-modal-scrollable" v-if="showModalDiario">
                <div class="container nb-modal-scrollable-container nb-email-container">
                    <div class="nb-modal-header">
                        <h5 class="p-2" v-if="diario.dataDia === 'Atrasos'">Detalhes {{ diario.dataDia }}</h5>
                        <h5 class="p-2" v-else>Detalhes do dia {{ diario.dataDia | formatData }}</h5>
                        <button type="button" class="close" @click="closeModalDetalhes()" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="nb-modal-scrollable-body">
                        <div class="mainbox">
                            <div class="box" v-for="(detalhe, index) in diario.diarioDetalhes" :key="index">
                                <div class="row">
                                    <div class="col-md-1 col-3" style="float: left">
                                        <label class="lbl-list w-100">Documento</label><span class="data-list">{{ detalhe.doc }}</span>
                                    </div>
                                    <div class="col-md-3 col-3">
                                        <label class="lbl-list w-100">Nome</label><span class="data-list">{{ detalhe.nome }}</span>
                                    </div>
                                    <div class="col-md-2 col-3">
                                        <label class="lbl-list w-100">Descrição</label><span class="data-list">{{ detalhe.descricao }}</span>
                                    </div>
                                    <div class="col-md-1 col-3">
                                        <label class="lbl-list w-100">Valor</label><span class="data-list">{{ detalhe.vlr | formatValue(2, true) }}</span>
                                    </div>
                                    <div class="col-auto text-center">
                                        <label class="lbl-list w-100">Tipo</label>
                                        <span v-if="detalhe.tipo == 'R' || detalhe.tipo == 'E'" class="tipo tipo-recebimento" data-toggle="tooltip" data-placement="top" title="Recebimento"> {{ detalhe.tipo }} </span>
                                        <span v-if="detalhe.tipo == 'P' || detalhe.tipo == 'S'" class="tipo tipo-pagamento" data-toggle="tooltip" data-placement="top" title="Pagamento"> {{ detalhe.tipo }} </span>
                                    </div>
                                    <div class="col-md-2 col-3">
                                        <label class="lbl-list w-100">Vencimento</label><span class="data-list">{{ detalhe.dtv | formatData }}</span>
                                    </div>
                                    <div class="col-md-2 col-3">
                                        <label class="lbl-list w-100">Vencimento Real</label><span class="data-list">{{ detalhe.dtvr | formatData }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="nb-modal-scrollable-footer">
                            <v-button ref="btnClose" label="Cancelar" title="" @click="closeModalDetalhes()"></v-button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>

.data-table {
    overflow: auto;
}

span i {
    cursor: pointer;
}

.lvl-1 {
    margin-left: .5rem;
}

.lvl-2 {
    font-size: 15px !important;
    margin-left: 1.5rem;
}

.lvl-3 {
    margin-left: 2.5rem;
}

.lvl-4 {
    font-weight: 400;
    margin-left: 3.5rem;
}

table .textual {
    font-size: 12px;
    padding: 4.8px;
}

table .numerico {
    font-size: 12px;
    min-width: 65px;
    text-align: right;
}

table .size130 {
  min-width: 130px;
}

table .size100 {
  width: 100px;
}

table .total {
    background: #c1c4c7;
    border: none;
}

table .var {
    min-width: 85px;
    text-align: center;
    background: #c1c4c7;
    display: inline-block;
}

table .var-negative {
    color: white;
    background: indianred;
}

table .var-positive {
    color: white;
    background: green;
}

table .border-left {
  border-left: 1px solid #dee2e6;
}

.value-bg-color {
    background-color: #fafffa !important;
}

.consulta__total {
  display: flex;
  align-items: center;
  justify-content: center;
}

.consulta__total_valor {
  font-size: 40px;
  display: block;
  line-height: normal;
}

.consulta__cifrao {
  font-size: 16px;
  display: block;
  line-height: normal;
}

.negative {
  color: red;
}

.positive {
  color: green
}

.tipo {
    display: inline-block;
    padding: 5px;
    font-size: 13px;
    font-weight: 600;
    line-height: 1;
    text-align: center;
    white-space: nowrap;
    vertical-align: baseline;
    border-radius: 20%;
}

.tipo-recebimento {
    color: #fff;
    background-color: #80b852;
}

.tipo-pagamento {
    color: #fff;
    background-color: #ee2727;
}

</style>



// WEBPACK FOOTER //
// src/forms-consultas/consulta-fluxo-caixa.vue